import client from './client';
import type { User } from '../types';

export const fetchCurrentUser = async (): Promise<User> => {
  const response = await client.get<User>('/users/me');
  return response.data;
};

export const createCurrentUser = async (data: Pick<User, 'name' | 'email'>): Promise<User> => {
  const response = await client.post<User>('/users/', data);
  return response.data;
};

export const updateUserProfile = async (data: {
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  dob: string;
}): Promise<User> => {
  const response = await client.put<User>('/users/profile', data);
  return response.data;
};

export const checkUserAvailability = async (params: { username?: string; email?: string }) => {
  const response = await client.get<{ username_available?: boolean; email_available?: boolean }>('/users/availability', {
    params,
  });
  return response.data;
};

export const updateCurrentUser = async (data: Partial<User>): Promise<User> => {
  const response = await client.put<User>('/users/me', data);
  return response.data;
};
